export const THREAD_LIST = {
    INITIAL_NUM: 40,
    LIMIT: 10
};

export const ANSWER_EVALUATE = {
    LIKE: 1,
    DISLIKE: 2
};

export const AI_MODEL_NAME = {
    GPTMODEL_DEFAULT: "5-mini",
    GPTMODEL_CHANGE: "GPT-5"
};

export const AI_MODEL_VALUE = {
    GPTMODEL_DEFAULT: "gpt-5-mini",
    GPTMODEL_CHANGE: "gpt-5.1"
};

export const AI_MODEL_DISP_NAME = {
    GPTMODEL_DISP_DEFAULT: "5-mini",
    GPTMODEL_DISP_CHANGE: "GPT-5"
};

export const MENU = {
    CUSTOM_INSTRUCTIONS: "カスタム指示設定",
    CLEAR_CONVERSATIONS: "チャット履歴を全て削除する",
    SETTINGS: "設定",
    SIGN_OUT: "サインアウト"
};

export const DEFAULT_THREAD_TITLE = "新しいチャット";
export const TEXTAREA_MAX_NUM_CHARACTERS = 1500;
export const THREAD_TITLE_MAX_NUM_CHARACTERS = 24;
export const USE_THIS_PROMPT = "利用する";

export const CSS_PROPS = {
    QUESTION_INPUT_TEXT_AREA: {
        MIN_HEIGHT: 56,
        MAX_HEIGHT: 300
    }
};
